import React, { useContext } from "react";
const ONBehalfContext = React.createContext<any>(null);

export function useOnBehalfContext() {
  return useContext(ONBehalfContext);
}

export function OnBehalfProvider({ children }: any) {
  const [onBehalfContext, setOnBehalfContext] = React.useState<Object>({
    name: "",
    id: "",
  });

  React.useEffect(() => {
    const onBehalfName = localStorage.getItem("onBehalfName") ?? "";
    const onBehalf = localStorage.getItem("onBehalf") ?? "";

    if (onBehalfName || onBehalf) {
      setOnBehalfContext({ name: onBehalfName, id: onBehalf });
    }
  }, []);
  return (
    <ONBehalfContext.Provider value={{ onBehalfContext, setOnBehalfContext }}>
      {children}
    </ONBehalfContext.Provider>
  );
}
